import { createCommentVNode as e, createElementBlock as t, createElementVNode as n, createVNode as r, defineComponent as i, openBlock as a, unref as o } from "vue";
import { ScalarWrappingText as s } from "@scalar/components/wrapping-text";
import { ScalarMarkdown as c } from "@scalar/components/markdown";
//#region src/schema/SchemaEnumPropertyItem.vue?vue&type=script&setup=true&lang.ts
var l = { class: "property-enum-row flex flex-col gap-0.5 border-t px-3 py-2" }, u = { class: "property-enum-row-label font-code text-c-1 text-sm" }, d = {
	key: 0,
	class: "property-enum-row-description text-c-2 text-(length:--scalar-small) [&_.markdown]:-mb-0.5"
}, f = /*@__PURE__*/ i({
	__name: "SchemaEnumPropertyItem",
	props: {
		label: {},
		description: {}
	},
	setup(i) {
		return (f, p) => (a(), t("li", l, [n("span", u, [r(o(s), {
			preset: "property",
			text: i.label
		}, null, 8, ["text"])]), i.description ? (a(), t("span", d, [r(o(c), { value: i.description }, null, 8, ["value"])])) : e("", !0)]));
	}
});
//#endregion
export { f as default };

//# sourceMappingURL=SchemaEnumPropertyItem.vue_vue_type_script_setup_true_lang.js.map